export default {
  methods: {
    ifFormValid(event, callback) {
      let target = event.target;
      if ($(target).valid()) {
        callback();
      }else{

        $('html, body').animate({
          scrollTop: $('label.error').closest('.form-group').eq(0).offset().top - 65
        }, 500);
      }
    },

    validateForm(form, userRules, userMessages, extraOptions) {

      // Optional: To validate rut Chile
      $.validator.addMethod("rut", function (value) {
        value = value.toLowerCase();
        var rut = value.split('-')[0];
        rut = rut.replace(/\./g, "");
        var digit = value.split('-')[1];

        function dv(T) {
          var M = 0, S = 1;
          for (; T; T = Math.floor(T / 10)) {
            S = (S + T % 10 * (9 - M++ % 6)) % 11;
          }
          return S ? S - 1 : 'k';
        }

        return dv(rut) == digit;
      }, 'Por favor, ingresa un rut válido');

      // Optional: To validate only digits but allow spaces
      $.validator.addMethod('digitsSpacesAllowed', function (value) {
        var pattern = /^([0-9]{2,}\s?)+$/;
        return pattern.test(value);
      }, 'Por favor, ingresa solo números');

      $.validator.addMethod('rutDuplicado', function (value) {
        const studentsJson = localStorage.getItem("students");
        const students = Array.isArray(JSON.parse(studentsJson)) ? JSON.parse(studentsJson) : [];
        return students.filter(student=>student.rut === value).length < 1;
      }, 'Este rut ya esta en la orden');

      // Optional: To validate letters only but allow spaces
      $.validator.addMethod('lettersonly', function (value) {
        var fullNamePattern = /^([a-zA-ZñÑáéíóúÁÉÍÓÚ]{1,}\s?)+$/;
        return fullNamePattern.test(value);
      }, 'Por favor, ingresa solo letras');

      // Optional: To validate email correctly
      $.validator.methods.email = function (value, element) {
        //return this.optional(element) || /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(value);
        return this.optional(element) || /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(value);
      };

      // Default options, you can modify each option to be different on some forms passing an object
      // as 4 parameter of function
      let validateDefaultOptions = {
        ignore:"",
        rules: userRules,
        messages: userMessages,
        focusCleanup: true,
        focusInvalid: false,
        onkeyup: false,
        onclick: false,
        errorPlacement: function (error, element) {
          if (element.hasClass('withErrorContainer')) {
            error.appendTo(element.closest('.form-group').find('.errorContainer'));
          } else if (element.is('select')) {
            error.insertAfter(element.closest('.form-group').find('.select2.select2-container'));
          } else {
            error.insertAfter(element);
          }
          element.closest('.form-group').addClass('error');
        },
        // Clear error when required - Works if you follow the bootstrap html structure of forms
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass(errorClass).addClass(validClass);
          let $formGroup = $(element).closest('.form-group');
          $formGroup.removeClass('error');
          $formGroup.find('label.error').remove();
        }
      };

      let extraOptionsSelector = extraOptions || {};

      let validateOptions = $.extend({}, validateDefaultOptions, extraOptionsSelector);
      form.validate(validateOptions);
    }
  }
};
